/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Requirement/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import CreateNewTask from './CreateNewTask/index'
import CreateTask from './CreateTask/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import IsSkippable from './IsSkippable/index'
import Name from './Name/index'
import NewTask from './NewTask/index'
import React from 'react'
import Task from './Task/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Requirement({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CheckRequirements/Requirement"
  
}) {
let requirementItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'requirement_item',
path: 'isFirst',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<fromFlow.When is={!requirementItemIsFirstValueData}>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
 data="requirement_item.isFirst"
/>
</fromFlow.When>
<div
  data-testid="Requirement.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-2oH0XH': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<IsSkippable
  viewPath={`${viewPath}/IsSkippable`}
/>
<CreateTask
  viewPath={`${viewPath}/CreateTask`}
/>
<CreateNewTask
  viewPath={`${viewPath}/CreateNewTask`}
/>
</div>
<Task
  viewPath={`${viewPath}/Task`}
/>
<NewTask
  viewPath={`${viewPath}/NewTask`}
/>
{children}
</React.Fragment>)
}